import React from "react";
import PageTemplate from "../components/PageTemplate";

function Mains() {
  return (
    <PageTemplate title="Mains">
      <p>The heart of the table — mains and sides cooking up soon!</p>
    </PageTemplate>
  );
}

export default Mains;
